<template>
  <div class="pa-2">
    <v-dialog
      v-model="dialog"
      max-width="1250px"
      @click:outside="cerrarDialogo(false)"
      @keydown.esc="cerrarDialogo(false)"
      scrollable
    >
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header -->
        <v-toolbar height="60" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-tire</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Item.id == null ? "Registro de Neumático" : "Editar Neumático" }}
          </span>
          <v-chip
            v-if="Item.id != null"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-pound</v-icon>
            ID: {{ Item.id }}
          </v-chip>
          <v-chip
            v-if="Item.id != null && Item.num_serie"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-2 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-barcode-scan</v-icon>
            Serie: {{ Item.num_serie }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogo(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Alerta de permisos -->
        <v-slide-y-transition>
          <v-alert
            v-if="snackbarPermisos"
            type="warning"
            dense
            text
            dismissible
            class="mx-4 mt-3 mb-0 rounded-md"
            @input="snackbarPermisos = false"
          >
            Para realizar esta acción debe solicitar autorización a su
            supervisor.
          </v-alert>
        </v-slide-y-transition>

        <v-card-text
          class="pa-5"
          style="max-height: calc(90vh - 130px); overflow-y: auto"
        >
          <v-form enctype="multipart/form-data" ref="form" v-model="valid_form">
            <v-row>
              <!-- COLUMNA IZQUIERDA: IDENTIFICACIÓN O LOTE DE SERIES -->
              <v-col cols="12" md="3" sm="4" class="pr-md-3">
                <!-- MODO GRUPO / LOTE -->
                <div
                  v-if="showGroups == true"
                  class="batch-panel fill-height pa-1 rounded-lg d-flex flex-column"
                >
                  <div class="d-flex align-center justify-space-between mb-3">
                    <div class="d-flex align-center">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-barcode-scan</v-icon
                      >
                      <span
                        class="font-weight-bold text-subtitle-2 text--primary"
                        >Series en Lote</span
                      >
                    </div>
                    <v-chip
                      x-small
                      :color="
                        neumaticoGroup.length > 0 ? 'primary' : 'grey lighten-2'
                      "
                      :text-color="
                        neumaticoGroup.length > 0 ? 'white' : 'grey darken-2'
                      "
                      class="font-weight-bold"
                    >
                      {{ neumaticoGroup.length }} unid.
                    </v-chip>
                  </div>

                  <v-btn
                    color="primary"
                    x-small
                    height="28"
                    class="px-3 text-capitalize font-weight-bold elevation-1"
                    @click="openModalGroup()"
                  >
                    <v-icon left size="16">mdi-plus</v-icon>
                    Agregar Serie
                  </v-btn>

                  <div class="group-table-wrapper flex-grow-1 mb-2">
                    <neumatico-group
                      :neumaticoGroup="neumaticoGroup"
                    ></neumatico-group>
                  </div>

                  <div v-if="neumaticoGroup.length == 0" class="mt-1 mb-2">
                    <v-alert
                      dense
                      type="error"
                      text
                      class="text-caption mb-0 py-2"
                    >
                      Ingrese las series del lote *
                    </v-alert>
                  </div>

                  <v-btn
                    v-if="neumaticoGroup.length > 0"
                    color="error"
                    text
                    small
                    block
                    class="mt-auto text-capitalize"
                    @click="emptyGroups()"
                  >
                    <v-icon left small>mdi-trash-can-outline</v-icon>
                    Limpiar lista
                  </v-btn>
                </div>

                <!-- MODO INDIVIDUAL / EDICIÓN -->
                <div v-else class="single-panel fill-height pa-3 rounded-lg">
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="primary" class="mr-1"
                      >mdi-barcode-scan</v-icon
                    >
                    <span class="font-weight-bold text-subtitle-2 text--primary"
                      >Identificación</span
                    >
                  </div>
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        label="N° de serie *"
                        v-model="Item.num_serie"
                        outlined
                        dense
                        prepend-inner-icon="mdi-barcode"
                        hide-details="auto"
                        required
                        :rules="[(v) => !!v || 'N° de serie es requerido']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="mt-3">
                      <v-text-field
                        label="Serie del cliente"
                        v-model="Item.serie_cliente"
                        outlined
                        dense
                        prepend-inner-icon="mdi-identifier"
                        hide-details="auto"
                        placeholder="Opcional / DOT"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-divider vertical class="hidden-xs-only"></v-divider>

              <!-- COLUMNA DERECHA: ESPECIFICACIONES Y DETALLES -->
              <v-col cols="12" md="9" sm="8" class="pl-md-4">
                <!-- SECCIÓN 1: Condición y Valorización Comercial -->
                <div class="mb-4">
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-cash-multiple</v-icon
                    >
                    <span class="text-subtitle-1 font-weight-bold text--primary"
                      >Condición y Valorización Comercial</span
                    >
                  </div>

                  <v-row dense>
                    <!-- Costo sin IGV -->
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        type="number"
                        min="0"
                        step="0.01"
                        label="Costo sin IGV *"
                        v-model="Item.precio"
                        outlined
                        dense
                        prepend-inner-icon="mdi-cash"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Costo es requerido']"
                      ></v-text-field>
                    </v-col>

                    <!-- Moneda -->
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        :items="monedaList"
                        v-model="Item.tipo_moneda"
                        label="Moneda *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-currency-usd"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Moneda es requerido']"
                      ></v-select>
                    </v-col>

                    <!-- Condición del neumático -->
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        :items="condicionNeumaticoList"
                        v-model="Item.nuevo"
                        label="Condición del neumático *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-tag-outline"
                        hide-details="auto"
                        @change="limpiarRemanentes"
                        :disabled="Item.id != null"
                        :rules="[
                          (v) =>
                            v === 0 ||
                            v === 1 ||
                            'Condición de neumáticos es requerido',
                        ]"
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>

                <!-- SECCIÓN CONDICIONAL: Datos de Reencauche (solo si es Reencauchado) -->
                <v-slide-y-transition>
                  <div v-if="Item.nuevo == 0" class="mb-4">
                    <v-divider class="my-3"></v-divider>
                    <div class="d-flex align-center mb-3">
                      <v-icon small color="primary" class="mr-2"
                        >mdi-cog-sync-outline</v-icon
                      >
                      <span
                        class="text-subtitle-1 font-weight-bold text--primary"
                        >Datos de Reencauche</span
                      >
                    </div>

                    <v-row dense>
                      <!-- Cantidad de reencauches -->
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          :items="cantidadReencaucheList"
                          v-model="Item.cantidad_reencauche"
                          label="Cantidad de reencauches *"
                          outlined
                          dense
                          prepend-inner-icon="mdi-numeric"
                          hide-details="auto"
                          :rules="[
                            (v) =>
                              !!v || 'Cantidad de reencauches es requerido',
                          ]"
                        ></v-autocomplete>
                      </v-col>

                      <!-- Diseño de Banda -->
                      <v-col cols="12" sm="6" md="4">
                        <div class="d-flex align-center">
                          <v-autocomplete
                            :items="disenioNeumaticoList"
                            v-model="Item.id_disenio"
                            label="Diseño de Banda *"
                            outlined
                            dense
                            prepend-inner-icon="mdi-tire"
                            hide-details="auto"
                            :rules="[(v) => !!v || 'Diseño es requerido']"
                            class="mr-2"
                          ></v-autocomplete>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                height="40"
                                width="40"
                                class="elevation-1 flex-shrink-0"
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click="openModalDisennio()"
                              >
                                <v-icon small>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>Nuevo Diseño</span>
                          </v-tooltip>
                        </div>
                      </v-col>

                      <!-- Empresa Reencauchadora -->
                      <v-col cols="12" sm="6" md="4">
                        <div class="d-flex align-center">
                          <v-autocomplete
                            :items="empresaList"
                            v-model="Item.id_empresa"
                            label="Empresa Reencauchadora *"
                            outlined
                            dense
                            prepend-inner-icon="mdi-domain"
                            hide-details="auto"
                            :rules="[(v) => !!v || 'Empresa es requerido']"
                            class="mr-2"
                          ></v-autocomplete>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                height="40"
                                width="40"
                                class="elevation-1 flex-shrink-0"
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click="openModalEmpresa()"
                              >
                                <v-icon small>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>Nueva Empresa</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-slide-y-transition>

                <v-divider class="my-3"></v-divider>

                <!-- SECCIÓN 2: Clasificación y Catálogo -->
                <div class="mb-4">
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-shape-outline</v-icon
                    >
                    <span class="text-subtitle-1 font-weight-bold text--primary"
                      >Clasificación y Catálogo</span
                    >
                  </div>

                  <v-row dense>
                    <!-- Marca de neumático -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="d-flex align-center">
                        <v-autocomplete
                          :items="marcaNeumaticoList"
                          v-model="Item.id_marca"
                          label="Marca de neumático *"
                          outlined
                          dense
                          prepend-inner-icon="mdi-watermark"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'Marca es requerido']"
                          @change="cargarModelos(Item.id_marca)"
                          class="mr-2"
                        ></v-autocomplete>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              height="40"
                              width="40"
                              class="elevation-1 flex-shrink-0"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openModalMarca()"
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Nueva Marca</span>
                        </v-tooltip>
                      </div>
                    </v-col>

                    <!-- Modelo de neumático -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="d-flex align-center">
                        <v-autocomplete
                          :items="modeloNeumaticoPorMarcaList"
                          v-model="Item.id_modelo"
                          label="Modelo de neumático *"
                          outlined
                          dense
                          prepend-inner-icon="mdi-car-tire-alert"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'Modelo es requerido']"
                          class="mr-2"
                        ></v-autocomplete>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              height="40"
                              width="40"
                              class="elevation-1 flex-shrink-0"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openModalModelo()"
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Nuevo Modelo</span>
                        </v-tooltip>
                      </div>
                    </v-col>

                    <!-- Medida de neumático -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="d-flex align-center">
                        <v-autocomplete
                          :items="medidaNeumaticoList"
                          v-model="Item.id_medida"
                          label="Medida de neumático *"
                          outlined
                          dense
                          prepend-inner-icon="mdi-ruler-square"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'Medida es requerido']"
                          class="mr-2"
                        ></v-autocomplete>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              height="40"
                              width="40"
                              class="elevation-1 flex-shrink-0"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openModalMedida()"
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Nueva Medida</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <v-divider class="my-3"></v-divider>

                <!-- SECCIÓN 3: Parámetros Técnicos y Rodado -->
                <div>
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-gauge</v-icon
                    >
                    <span class="text-subtitle-1 font-weight-bold text--primary"
                      >Parámetros Técnicos y Rodado</span
                    >
                  </div>

                  <v-row dense>
                    <!-- Profundidad de rodado original/reencauche -->
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-mask="numberDecimal"
                        hint="(rec. <= 125 mm)"
                        persistent-hint
                        v-model="Item.remanente_original"
                        placeholder="00.00"
                        :label="
                          Item.nuevo != 0
                            ? 'Profundidad rodado original *'
                            : 'Profundidad rodado reencauche *'
                        "
                        outlined
                        dense
                        suffix="mm"
                        prepend-inner-icon="mdi-ruler"
                        hide-details="auto"
                        :rules="validarRemanenteOriginal"
                        @change="handleRemanenteOriginalChange"
                      ></v-text-field>
                    </v-col>

                    <!-- Profundidad de rodado actual -->
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        id="remanente_actual"
                        disabled
                        v-mask="numberDecimal"
                        hint="(rec. <= 125 mm)"
                        persistent-hint
                        v-model="Item.remanente_actual"
                        placeholder="00.00"
                        label="Profundidad rodado actual *"
                        outlined
                        dense
                        suffix="mm"
                        prepend-inner-icon="mdi-ruler"
                        hide-details="auto"
                        :rules="validarRemanenteActual"
                      ></v-text-field>
                    </v-col>

                    <!-- Presión recomendada -->
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-mask="numberEntero"
                        hint="(rec. <= 160 PSI)"
                        persistent-hint
                        v-model="Item.presion_recomendada"
                        placeholder="0"
                        label="Presión recomendada *"
                        outlined
                        dense
                        suffix="PSI"
                        prepend-inner-icon="mdi-gauge"
                        hide-details="auto"
                        :rules="presionRecomendada"
                      ></v-text-field>
                    </v-col>

                    <!-- K/H de instalación -->
                    <v-col cols="12" sm="6" md="4" class="mt-2">
                      <v-select
                        :items="opcionesInstalacion"
                        v-model="Item.unidad_medida"
                        label="K/H de instalación *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-speedometer"
                        hide-details="auto"
                        :rules="[
                          (v) => !!v || 'Opciones de instalación es requerido',
                        ]"
                      ></v-select>
                    </v-col>

                    <!-- Km / Hr de Instalación -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="mt-2"
                      v-if="Item.id == null"
                    >
                      <v-text-field
                        type="number"
                        placeholder="00.00"
                        v-model="Item.km_instalacion"
                        outlined
                        dense
                        prepend-inner-icon="mdi-counter"
                        hide-details="auto"
                        :label="
                          Item.unidad_medida === 'H'
                            ? 'Hr de instalación'
                            : 'Km de Instalación'
                        "
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="mt-2"
                      v-if="Item.id != null"
                    >
                      <div class="d-flex align-center">
                        <v-text-field
                          type="number"
                          placeholder="0"
                          v-model="Item.km_instalacion"
                          :disabled="!Item.edit_status"
                          outlined
                          dense
                          prepend-inner-icon="mdi-counter"
                          hide-details="auto"
                          :label="
                            Item.unidad_medida === 'H'
                              ? 'Hr de instalación'
                              : 'Km de Instalación'
                          "
                          class="mr-2"
                        ></v-text-field>
                      </div>
                    </v-col>

                    <!-- Fecha de Instalación -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="mt-2"
                      v-if="Item.id != null"
                    >
                      <div class="d-flex align-center">
                        <v-text-field
                          type="date"
                          v-model="Item.fecha_instalacion"
                          :disabled="!Item.edit_status"
                          outlined
                          dense
                          prepend-inner-icon="mdi-calendar"
                          hide-details="auto"
                          label="Fecha de Instalación"
                          class="mr-2"
                        ></v-text-field>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :color="
                                !Item.has_instalacion
                                  ? 'grey'
                                  : Item.edit_status
                                  ? 'warning'
                                  : 'success'
                              "
                              height="40"
                              width="40"
                              class="elevation-1 flex-shrink-0"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                Item.has_instalacion
                                  ? Item.edit_status
                                    ? $set(Item, 'edit_status', false)
                                    : habilitarEdicionKilometraje()
                                  : null
                              "
                            >
                              <v-icon small>
                                {{
                                  Item.edit_status && Item.has_instalacion
                                    ? "mdi-lock-open-variant-outline"
                                    : "mdi-lock-outline"
                                }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{
                              !Item.has_instalacion
                                ? "Este neumático no está instalado para poder editar los datos de instalación"
                                : Item.edit_status
                                ? "Bloquear edición"
                                : "Solicitar desbloqueo de kilometraje y fecha"
                            }}
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>

                    <!-- Ply Rating -->
                    <v-col cols="12" sm="6" md="4" class="mt-2">
                      <v-text-field
                        type="number"
                        placeholder="0"
                        label="Ply Rating"
                        v-model="Item.ply_rating"
                        outlined
                        dense
                        prepend-inner-icon="mdi-layers-outline"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Footer Actions -->
        <v-card-actions class="pa-4 bg-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-2"
            class="mr-2 text-capitalize px-4"
            @click="cerrarDialogo(false)"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            :loading="loader"
            class="px-6 text-capitalize font-weight-bold elevation-1"
            @click="agregar()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            {{ Item.id == null ? "Guardar" : "Actualizar" }}
          </v-btn>
        </v-card-actions>

        <MensajeTransicion
          color="#FA694A"
          :text="mensaje"
          v-if="verAlerta"
          :top="true"
          :bottom="false"
        />
      </v-card>
    </v-dialog>

    <!--MODAL ADD GROUP-->
    <v-dialog v-model="dialogGroup" max-width="420px">
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Agregar Serie a Lote</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialogGroup = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form_group" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="N° de serie *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-barcode"
                    v-model="group.num_serie"
                    :rules="[(v) => !!v || 'Serie es requerida']"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <v-text-field
                    label="Serie del cliente / DOT"
                    outlined
                    dense
                    prepend-inner-icon="mdi-identifier"
                    v-model="group.serie_cliente"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Serie de neumático duplicada
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="dialogGroup = false">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="loadingGroup"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addGroup(group)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MARCA-->
    <v-dialog v-model="dialogMarca" max-width="420px">
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nueva Marca de Neumático</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialogMarca = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form-marca" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre de la marca *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-watermark"
                    v-model="marca.descripcion"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Marca duplicada
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="dialogMarca = false">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addMarca(marca)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD DISENIO-->
    <v-dialog v-model="dialogDisenio" max-width="420px">
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nuevo Diseño de Banda</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialogDisenio = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form-disenio" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="Diseño *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-tire"
                    v-model="disenio.nombre"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Diseño Duplicado
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="dialogDisenio = false">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addDisenio(disenio)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD EMPRESA-->
    <v-dialog
      v-model="dialogEmpresa"
      max-width="450px"
      v-if="dialogEmpresa == true"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nueva Empresa Reencauchadora</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialogEmpresa = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form_empresa" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-mask="numberRUC"
                    label="RUC *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-card-account-details"
                    v-model="empresa.ruc"
                    :rules="[(v) => !!v || 'RUC es requerido']"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <v-text-field
                    label="Razón social *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-domain"
                    v-model="empresa.razon_social"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    RUC duplicado
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="dialogEmpresa = false">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addEmpresa(empresa)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MODELO-->
    <v-dialog
      v-if="modal_form_modelo"
      v-model="dialogModelo"
      max-width="450px"
      @click:outside="cerrarDialogModelo"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nuevo Modelo de Neumático</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogModelo">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form-modelo" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-autocomplete
                    :items="marcaNeumaticoList"
                    v-model="modelo.id_marca"
                    label="Marca de neumático *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-watermark"
                    :rules="[(v) => !!v || 'Marca es requerido']"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <v-text-field
                    label="Nombre del modelo *"
                    placeholder="Ej. HN08"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-car-tire-alert"
                    v-model="modelo.descripcion"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Modelo Duplicado
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogModelo">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addModelo(modelo)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MEDIDA-->
    <v-dialog
      v-if="modal_form_medida"
      v-model="dialogMedida"
      max-width="480px"
      @click:outside="cerrarDialogMedida"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nueva Medida de Neumático</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogMedida">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form-medida" v-model="valid">
              <v-row dense>
                <v-col cols="12" sm="4">
                  <v-text-field
                    hint="Ej. 275"
                    persistent-hint
                    label="Ancho *"
                    outlined
                    dense
                    @change="onEscribirDescripcion"
                    v-model="medida.ancho"
                    :rules="[(v) => !!v || 'Ancho es requerido']"
                    type="number"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    hint="Ej. 70"
                    persistent-hint
                    label="Perfil"
                    outlined
                    dense
                    @change="onEscribirDescripcion"
                    v-model="medida.perfil"
                    type="number"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    hint="Ej. 22.5"
                    persistent-hint
                    label="Aro *"
                    outlined
                    dense
                    @change="onEscribirDescripcion"
                    v-model="medida.aro"
                    :rules="[(v) => !!v || 'Aro es requerido']"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <v-text-field
                    hint="Ej. 275/70R22.5"
                    :readonly="!checkbox"
                    persistent-hint
                    label="Medida / Descripción *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-ruler-square"
                    v-model="medida.descripcion"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Medida Duplicada
                  </v-alert>
                </v-col>
                <v-col cols="12" class="pt-2">
                  <v-checkbox
                    v-model="checkbox"
                    label="Activar edición manual de descripción"
                    dense
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogMedida">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addMedida(medida)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import neumaticoGroup from "./groups.vue";
import MensajeTransicion from "../Alerta.vue";
import global from "@/global";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { notif } from "@/plugins/notyf";
//https://github.com/text-mask/text-mask/tree/master/addons/#createnumbermask

const numberDecimal = createNumberMask({
  prefix: "",
  integerLimit: 3,
  decimalLimit: 2,
  allowDecimal: true,
});

const numberEntero = createNumberMask({
  prefix: "",
  integerLimit: 3,
});

const numberRUC = createNumberMask({
  prefix: "",
  integerLimit: 11,
  decimalLimit: 0,
  allowDecimal: false,
  includeThousandsSeparator: false,
});

export default {
  components: {
    MensajeTransicion,
    neumaticoGroup,
  },
  props: [
    "dialog",
    "Item",
    "Titulo",
    "showGroups",
    "propiedadMd",
    "neumaticoCondicionList",
    "marcaNeumaticoList",
    "modeloNeumaticoList",
    "medidaNeumaticoList",
    "disenioNeumaticoList",
    "empresaList",
  ],
  data() {
    return {
      numberDecimal,
      numberEntero,
      numberRUC,
      modal_form_medida: true,
      modal_form_modelo: true,
      checkbox: false,
      valid: false,
      dialogGroup: false,
      dialogMarca: false,
      dialogModelo: false,
      dialogMedida: false,
      dialogDisenio: false,
      dialogEmpresa: false,
      valid_form: false,
      neumaticoGroup: [],
      group: {},
      marca: {},
      modelo: {},
      medida: {},
      disenio: {},
      empresa: {},
      condicionNeumaticoList: [
        {
          value: 1,
          text: "Nuevo",
        },
        {
          value: 0,
          text: "Reencauchado",
        },
      ],
      monedaList: [
        {
          value: 2,
          text: "$ Dólares",
        },
        {
          value: 1,
          text: "S/. Soles",
        },
      ],
      opcionesInstalacion: [
        {
          value: "K",
          text: "Kilómetros",
        },
        {
          value: "H",
          text: "Horas",
        },
      ],
      cantidadReencaucheList: [
        {
          value: 1,
          text: 1,
        },
        {
          value: 2,
          text: 2,
        },
        {
          value: 3,
          text: 3,
        },
        {
          value: 4,
          text: 4,
        },
        {
          value: 5,
          text: 5,
        },
        {
          value: 6,
          text: 6,
        },
      ],
      modeloNeumaticoPorMarcaList: [],
      profundidadRemanenteOriginal: [
        (v) => !!v || "Profundidad es requerida",
        (v) =>
          (v && v <= 125) ||
          "Profundidad recomendada debe ser (rec. <= 125 mm)",
      ],
      profundidadRemanenteActual: [
        (v) => !!v || "Profundidad es requerida",
        (v) =>
          (v && v <= 125) ||
          "Profundidad recomendada debe ser (rec. <= 125 mm)",
      ],
      presionRecomendada: [
        (v) => !!v || "La presión es requerida",
        (v) =>
          (v && v <= 160) ||
          "La presión recomendada debe ser (rec. <= 160 PSI)",
      ],
      validarRemanenteOriginal: this.profundidadRemanenteOriginal,
      validarRemanenteActual: this.profundidadRemanenteActual,
      descripcionRules: [(v) => !!v || "Descripción es requerido"],
      mostrarLabelDuplicado: false,
      verAlerta: false,
      mensaje: "",
      loader: false,
      loadingGroup: false,
      snackbarPermisos: false,
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
  },
  methods: {
    ...mapActions("neumatico", [
      "agregarNeumatico",
      "agregarItemArray",
      "validateSerialNumber",
    ]),

    onEscribirDescripcion() {
      if (this.medida.ancho == "") {
        this.medida.descripcion = this.medida.perfil + "R" + this.medida.aro;
      } else if (this.medida.perfil == "" && this.medida.aro == "") {
        this.medida.descripcion = this.medida.ancho;
      } else if (this.medida.perfil != "" && this.medida.aro == "") {
        this.medida.descripcion = this.medida.ancho + "/" + this.medida.perfil;
      } else if (
        this.medida.ancho != "" &&
        this.medida.aro != "" &&
        this.medida.perfil == ""
      ) {
        this.medida.descripcion = this.medida.ancho + "R" + this.medida.aro;
      } else {
        this.medida.descripcion =
          this.medida.ancho + "/" + this.medida.perfil + "R" + this.medida.aro;
      }
    },
    handleRemanenteOriginalChange() {
      console.log("aea", !this.Item.has_inspeccion);
      if (!this.Item.has_inspeccion) {
        // Temporalmente cambiar el valor para forzar una actualización en el DOM
        this.Item.remanente_actual = ""; // Cambiar temporalmente a un valor vacío
        this.$nextTick(() => {
          this.Item.remanente_actual = this.Item.remanente_original; // Restaurar el valor original
          document.getElementById("remanente_actual").value =
            this.Item.remanente_actual;
          console.log(
            "aea",
            this.Item.remanente_original,
            this.Item.remanente_actual,
          );
        });
      }
    },

    inicializarGroup: function () {
      this.group = {
        num_serie: null,
        serie_cliente: null,
      };
    },

    inicializarMarca: function () {
      this.marca = {
        descripcion: null,
      };
    },

    inicializarDisenio: function () {
      this.disenio = {
        nombre: null,
      };
    },

    inicializarEmpresa: function () {
      this.empresa = {
        ruc: "",
        razon_social: null,
      };
    },

    inicializarModelo: function () {
      this.modelo = {
        id_marca: null,
        descripcion: null,
      };
    },

    inicializarMedida: function () {
      this.medida = {
        descripcion: null,
        perfil: "",
        ancho: "",
        aro: "",
      };
    },

    openModalGroup: function () {
      this.inicializarGroup();
      this.loadingGroup = false;
      this.dialogGroup = true;
      this.mostrarLabelDuplicado = false;
      if (this.$refs.form_group) {
        this.$refs.form_group.resetValidation();
      }
    },

    openModalMarca: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarMarca();
      this.dialogMarca = true;
    },

    openModalModelo: function () {
      this.mostrarLabelDuplicado = false;
      this.$nextTick().then(() => {
        this.modal_form_modelo = true;
      });
      this.inicializarModelo();
      if (this.Item.id_marca != null) {
        this.modelo.id_marca = this.Item.id_marca;
      }
      this.dialogModelo = true;
    },

    openModalMedida: function () {
      this.mostrarLabelDuplicado = false;
      this.$nextTick().then(() => {
        this.modal_form_medida = true;
      });
      this.inicializarMedida();
      this.dialogMedida = true;
    },

    openModalDisennio: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarDisenio();
      this.dialogDisenio = true;
    },

    openModalEmpresa: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarEmpresa();
      this.dialogEmpresa = true;
    },

    emptyGroups: function () {
      this.neumaticoGroup = [];
      this.$forceUpdate();
    },

    addGroup: async function (item) {
      this.loadingGroup = true;
      let rpta = await this.validateSerialNumber(item.num_serie.toUpperCase());
      if (rpta == "") {
        let existe = this.neumaticoGroup.find(
          (el) => el.num_serie == item.num_serie.toUpperCase(),
        );
        let serie_cliente =
          item.serie_cliente == null ? null : item.serie_cliente.toUpperCase();

        if (existe == null) {
          this.neumaticoGroup.push({
            num_serie: item.num_serie.toUpperCase(),
            serie_cliente: serie_cliente,
          });
          this.dialogGroup = false;
          this.loadingGroup = false;
          this.$forceUpdate();
        } else {
          this.loadingGroup = false;
          this.mostrarLabelDuplicado = true;
        }
      } else {
        this.loadingGroup = false;
        this.mostrarLabelDuplicado = true;
        this.mensaje = rpta;
      }
    },

    addDisenio: async function (item) {
      if (
        !this.verificarDuplicados(
          this.disenioNeumaticoList,
          item.nombre.toUpperCase(),
        )
      ) {
        //Guardar en la base de datos
        item.nombre = item.nombre.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticodisenio/store",
          item: item,
        });
        this.disenioNeumaticoList.push({
          value: dato.id,
          text: dato.nombre,
        });
        this.dialogDisenio = false; //Dialog
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addMarca: async function (item) {
      if (
        !this.verificarDuplicados(
          this.marcaNeumaticoList,
          item.descripcion.toUpperCase(),
        )
      ) {
        //Guardar en la base de datos
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticomarca/store",
          item: item,
        });
        this.marcaNeumaticoList.push({
          value: dato.id,
          text: dato.descripcion,
        });
        this.dialogMarca = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addModelo: async function (item) {
      // Filtrar solo los modelos que ya pertenecen a la marca seleccionada EN EL MODAL
      const modelosDeEstaMarca = this.modeloNeumaticoList.filter(
        (el) => el.marca == item.id_marca   // ← antes: this.Item.id_marca
      );

      if (
        !this.verificarDuplicados(
          modelosDeEstaMarca,
          item.descripcion.toUpperCase(),
        )
      ) {
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticomodelo/store",
          item: item,
        });
        this.modeloNeumaticoList.push({
          value: dato.id,
          text: dato.descripcion,
          marca: dato.marca,
        });
        this.modeloNeumaticoPorMarcaList = [];
        if (this.Item.id_marca != null) {
          this.cargarModelos(this.Item.id_marca);
        }
        this.dialogModelo = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    // addModelo: async function (item) {
    //   if (
    //     !this.verificarDuplicados(
    //       this.modeloNeumaticoList,
    //       item.descripcion.toUpperCase(),
    //     )
    //   ) {
    //     item.descripcion = item.descripcion.toUpperCase();
    //     let dato = await this.agregarItemArray({
    //       url: "neumaticomodelo/store",
    //       item: item,
    //     });
    //     this.modeloNeumaticoList.push({
    //       value: dato.id,
    //       text: dato.descripcion,
    //       marca: dato.marca,
    //     });
    //     this.modeloNeumaticoPorMarcaList = [];
    //     if (this.Item.id_marca != null) {
    //       this.cargarModelos(this.Item.id_marca);
    //     }
    //     this.dialogModelo = false;
    //   } else {
    //     this.mostrarLabelDuplicado = true;
    //   }
    // },

    addEmpresa: async function (item) {
      let existe = false;
      this.empresaList.forEach((element) => {
        if (element.ruc == item.ruc) {
          existe = true;
        }
      });
      //!this.verificarDuplicados(this.empresaList,item.razon_social)
      if (!existe) {
        //Guardar en la base de datos
        item.razon_social = item.razon_social.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "empresas/store",
          item: item,
        });
        this.empresaList.push({
          value: dato.id,
          text: dato.razon_social,
        });
        this.dialogEmpresa = false; //Dialog
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addMedida: async function (item) {
      if (
        !this.verificarDuplicados(
          this.medidaNeumaticoList,
          item.descripcion.toUpperCase(),
        )
      ) {
        //Guardar en la base de datos
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticomedida/store",
          item: item,
        });
        this.medidaNeumaticoList.push({
          value: dato.id,
          text: dato.descripcion,
        });
        this.dialogMedida = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    cargarModelos: function (id_marca) {
      this.modeloNeumaticoPorMarcaList = [];
      this.modeloNeumaticoList.forEach((element) => {
        if (element.marca == id_marca) {
          this.modeloNeumaticoPorMarcaList.push(element);
        }
      });
    },

    verificarDuplicados: function (list, item) {
      let existe = false;
      list.forEach((element) => {
        if (element.text == item) {
          existe = true;
        }
      });
      return existe;
    },

    async agregar() {
      if (this.$refs.form.validate()) {
        this.loader = true;
        let datos = {
          grupo: this.neumaticoGroup,
          neumatico: this.Item,
        };

        if (this.neumaticoGroup.length == 0 && this.Item.id == null) {
          this.verAlerta = true;
          this.mensaje = "Agregue serie del neumático";
          setTimeout(() => [(this.verAlerta = false)], 4000);
          this.loader = false;
        } else {
          if (this.Item.id == null || this.Item.id == "") {
            await this.agregarNeumatico(datos)
              .then((r) => {
                //En la función se vuelve a cargar a los neumaticos
                this.neumaticoGroup.forEach((element) => {
                  notif.success(
                    "Se registro el neumático: " + element.num_serie,
                  );
                });

                this.$emit("actualizarListado");
                this.cerrarDialogo();
              })
              .catch((error) => {
                console.error("error!", error);
              });
          } else {
            await this.agregarNeumatico(datos).then((r) => {
              //En la función se vuelve a cargar a los neumaticos
              notif.success(
                "Se actualizó los datos del neumático: " + this.Item.num_serie,
              );
              this.$emit("actualizarListado");
              this.cerrarDialogo(false);
            });
          }
        }
      }
    },

    limpiarRemanentes: function () {
      this.Item.id_disenio = null;
      this.Item.cantidad_reencauche = null;
      this.Item.id_empresa = null;

      this.Item.remanente_actual = null;
      this.Item.remanente_original = null;
      this.asignarReglasRemanente();
    },

    asignarReglasRemanente: function () {
      if (this.Item.nuevo == 1) {
        this.validarRemanenteOriginal = this.profundidadRemanenteOriginal;
        this.validarRemanenteActual = [];
      } else {
        this.validarRemanenteActual = this.profundidadRemanenteActual;
        this.validarRemanenteOriginal = [];
      }
    },

    LimpiarCampos() {
      this.Item.id = null;
      this.Item.razon_social = "";
      this.Item.ruc = "";
      this.Item.estado = "";
      this.Item.ruta_logo = "";
      this.Item.costo = "";
      this.Item.imagen = "";
      this.Item.direccion = "";
    },

    cerrarDialogo() {
      this.loader = false;
      this.$emit("cerrarModal");
      this.neumaticoGroup = [];
    },

    cerrarDialogMedida() {
      this.dialogMedida = false;
      this.modal_form_medida = false;
    },

    cerrarDialogModelo() {
      this.dialogModelo = false;
      this.modal_form_modelo = false;
    },

    habilitarEdicionKilometraje() {
      const role = localStorage.getItem("role");
      if (role == 1 || role == 2) {
        this.$set(this.Item, "edit_status", true);
      } else {
        this.snackbarPermisos = true;
        setTimeout(() => {
          this.snackbarPermisos = false;
        }, 4000);
      }
    },
  },
  watch: {},
  mounted() {
    if (this.Item.id != null && this.Item.id != "") {
      this.asignarReglasRemanente();
      this.cargarModelos(this.Item.id_marca);
    }
  },
};
</script>
<style scoped>
.bg-actions {
  background-color: #f8fafc;
}

.batch-panel,
.single-panel {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
}

.group-table-wrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow-y: auto;
  min-height: 120px;
  max-height: 220px;
}

.alert-chiquito {
  font-size: 12px;
  padding: 4px 8px;
  margin: 4px 0;
  background-color: rgba(244, 67, 54, 0.1) !important;
  color: #000 !important;
}

.alert-chiquito.v-alert__wrapper.v-icon {
  color: red !important;
}
</style>
